<script setup>
import DesignWiseReport from './design-wise-report.vue'

definePage({
  meta: {
    subject: 'Design Number Wise Report',
  },
})
</script>

<template>
  <DesignWiseReport />
</template>
